import React from 'react';
import { CyberBackground, NeonText } from '../components/CyberEffects';
import './LegalPage.css';

function Legal({ navigate }) {
  return (
    <div className="legal-container animate-fade-in">
      <CyberBackground showParticles={false} />

      <div className="legal-content">
        <button className="back-btn" onClick={() => navigate('home')}>
          ← 戻る
        </button>

        <h1 className="legal-title">
          <NeonText color="accent" size="lg">特定商取引法に基づく表記</NeonText>
        </h1>

        <div className="legal-body">
          <div className="legal-section">
            <table className="legal-table">
              <tbody>
                <tr>
                  <th>販売業者</th>
                  <td>株式会社Eight Good</td>
                </tr>
                <tr>
                  <th>サービス名</th>
                  <td>クイズ ワン ワード</td>
                </tr>
                <tr>
                  <th>所在地</th>
                  <td>請求があった場合、遅滞なく開示いたします</td>
                </tr>
                <tr>
                  <th>電話番号</th>
                  <td>請求があった場合、遅滞なく開示いたします</td>
                </tr>
                <tr>
                  <th>メールアドレス</th>
                  <td>info@quiz-oneword.com</td>
                </tr>
                <tr>
                  <th>販売URL</th>
                  <td>https://quiz-oneword.com</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="legal-section">
            <h2>販売価格</h2>
            <table className="legal-table">
              <tbody>
                <tr>
                  <th>広告削除プラン</th>
                  <td>月額 300円（税込）</td>
                </tr>
                <tr>
                  <th>プレミアムプラン</th>
                  <td>月額 500円（税込）</td>
                </tr>
                <tr>
                  <th>開発者応援</th>
                  <td>1,000円（税込・1回限り）</td>
                </tr>
              </tbody>
            </table>
            <p>※ 価格は変更される場合があります。最新の価格は購入画面でご確認ください。</p>
          </div>

          <div className="legal-section">
            <h2>支払方法</h2>
            <p>クレジットカード（Visa、Mastercard、JCB、American Express）</p>
            <p>※ 決済処理は Stripe, Inc. を通じて安全に行われます。</p>
          </div>

          <div className="legal-section">
            <h2>支払時期</h2>
            <p>購入手続き完了時に即時決済されます。</p>
            <p>サブスクリプションは、契約期間終了時に自動更新・決済されます。</p>
          </div>

          <div className="legal-section">
            <h2>サービス提供時期</h2>
            <p>決済完了後、即時にサービスをご利用いただけます。</p>
          </div>

          <div className="legal-section">
            <h2>返品・キャンセルについて</h2>
            <p>
              デジタルコンテンツの性質上、購入後の返品・返金は原則としてお受けしておりません。
            </p>
            <p>
              サブスクリプションは、次回更新日の前日までにキャンセル手続きを行うことで、
              次回以降の課金を停止できます。既に支払済みの期間については、
              期間終了までサービスをご利用いただけます。
            </p>
          </div>

          <div className="legal-section">
            <h2>動作環境</h2>
            <ul>
              <li>対応ブラウザ: Chrome、Safari、Firefox、Edge（最新版推奨）</li>
              <li>対応OS: iOS 14以降、Android 8以降、Windows 10以降、macOS 10.15以降</li>
              <li>インターネット接続が必要です</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>お問い合わせ</h2>
            <div className="legal-contact">
              <p>メール: info@quiz-oneword.com</p>
              <p>受付時間: 24時間（回答は営業日内に行います）</p>
            </div>
          </div>
        </div>

        <p className="legal-date">最終更新日: 2026年1月23日</p>
      </div>
    </div>
  );
}

export default Legal;
